<template>
  <div class="deviceUpgrade-record">
    <div class="main-title">
      <p v-if="view=='list'" @click="cancelHandle">设备远程升级</p>
      <p v-if="view=='detail'" @click="cancelHandle">设备远程升级</p>
      <p v-if="view=='detail'">>任务详情</p>
    </div>
    <div class="main-body" v-if="view=='list'">
      <div class="list">
        <span>任务编号：</span>
        <el-input class="list-input" size="mini" placeholder="请输入任务编号" v-model="number"></el-input>
        <span class="ml10">任务状态：</span>
        <el-select
          class="fixed-width-100"
          size="mini"
          v-model="status">
          <el-option
            v-for="(item,key) in statusList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <span>创建时间：</span>
        <el-date-picker
          v-model="createTimeBegin"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="timestamp"
          placeholder="开始日期"
        ></el-date-picker>
        -
        <el-date-picker
          v-model="createTimeEnd"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="timestamp"
          placeholder="结束日期"
        ></el-date-picker>
      </div>
      <div class="list">
        <span>升级开始时间：</span>
        <el-date-picker
          v-model="startTimeBegin"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="timestamp"
          placeholder="开始日期"
        ></el-date-picker>
        -
        <el-date-picker
          v-model="startTimeEnd"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="timestamp"
          placeholder="结束日期"
        ></el-date-picker>
        <div class="blue-btn ml10" @click="onQueryBtnClick">查询</div>
        <div class="blue-btn ml10" @click="onAddBtnClick">新增任务</div>
      </div>
      <table class="table-custom">
        <thead>
        <tr>
          <th width="150px">任务编号</th>
          <th>创建时间</th>
          <th>升级开始时间</th>
          <th width="100px">任务状态</th>
          <th width="100px">升级设备类型</th>
          <th width="100px">设备数量</th>
          <th>备注</th>
          <th width="180px">操作</th>
        </tr>
        </thead>
        <tbody v-if="dataList.length>0">
        <tr v-for="(item,index) in dataList" :key="index">
          <td>{{ item.number }}</td>
          <td>{{ item.createTime }}</td>
          <td>{{ item.startTime }}</td>
          <td>{{ item.statusStr }}</td>
          <td>{{ item.deviceTypeStr }}</td>
          <td>{{ item.quantity }}</td>
          <td>{{ item.remark }}</td>
          <td>
            <div class="text-btn fixed-width-75" @click="onDetailBtnClick(item)">查看详情</div>
            <div class="text-btn fixed-width-75" v-if="item.status==0" @click="onStopClick(item)">中止任务</div>
            <div class="text-btn fixed-width-75" v-if="item.status==1" @click="onStopClick(item)">继续任务</div>
          </td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan='8'>暂无数据</td>
        </tr>
        </tbody>
      </table>
      <div class="page-box">
        <div class="page-count">第{{ pageIndex }}页，当前页{{ dataList.length }}条，共{{ total }}条</div>
        <div class="page-count">跳转到第
          <el-input v-model="page" class="page-choose fixed-width-35" size="mini"></el-input>
          页
        </div>
        <div class="page-count text-btn" @click="onPageChooseBtnClick">跳转</div>
        <div class="pre-btn" :class="preBtnDisabled?'disabled':''" @click="onPreBtnClick">上一页</div>
        <div class="next-btn" :class="nextBtnDisabled?'disabled':''" @click="onNextBtnClick">下一页</div>
      </div>
    </div>
    <div class="main-body" v-if="view == 'detail'">
      <device-upgrade-task-detail-view :edit-data="editData" :cancel="cancelHandle"></device-upgrade-task-detail-view>
    </div>
    <el-dialog title="新增任务" width="30%" :visible.sync="dialogVisible">
      <div style="display:flex; justify-content: flex-end;padding:10px 36px">
        <el-upload
          ref="fileUpload"
          action="/managementPlatform/admin/deviceUpgradeTaskItemFileLoad"
          accept=".xls, .xlsx"
          :limit="1"
          name="excelFile"
          :with-credentials="true"
          :show-file-list="false"
          :on-success="uploadSuccess"
          :file-list="uploadFileList"
        >
          <el-button style="background-color: yellowgreen">添加文件</el-button>
        </el-upload>
      </div>
      <el-form label-width="100px" :model="addData">
        <el-form-item label="设备类型">
          <el-input style="width: 300px;" v-model="addData.deviceType" readonly></el-input>
        </el-form-item>
        <el-form-item label="设备数量">
          <el-input style="width: 300px;" v-model="addData.quantity" readonly></el-input>
        </el-form-item>
        <el-form-item label="升级时间">
          <el-date-picker
            style="width: 300px;"
            v-model="addData.upgradeTime"
            type="datetime"
            placeholder="选择日期时间"
            value-format="timestamp"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="备注">
          <el-input style="width: 300px;" v-model="addData.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="confirmAdd">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Utils from "../../utils/utils";
import DeviceUpgradeTaskDetailView from "./deviceUpgradeTaskDetailView";

export default {
  name: 'deviceUpgradeTask',
  components: {DeviceUpgradeTaskDetailView},
  data() {
    return {
      view: 'list',
      title: '',
      pageSize: 10,
      beginIndex: 0,
      pageIndex: 1,
      page: 1,
      total: '',
      totalPage: 0,
      preBtnDisabled: true,
      nextBtnDisabled: false,
      number: '',
      startTimeBegin: "",
      startTimeEnd: "",
      createTimeBegin: '',
      createTimeEnd: '',
      status: '',
      statusList: [
        {
          id: '',
          name: '全部'
        }, {
          id: 0,
          name: '待升级'
        }, {
          id: 1,
          name: '中止'
        }, {
          id: 2,
          name: '升级中'
        }, {
          id: 3,
          name: '部分成功'
        }, {
          id: 4,
          name: '成功'
        }, {
          id: 5,
          name: '失败'
        }, {
          id: 6,
          name: '超时'
        }
      ],
      createTime: '',
      startTime: '',
      deviceType: '',
      quantity: '',
      remark: '',
      dataList: [],
      dialogVisible: false,
      file: null,
      uploadFileList: [],
      addData: {
        deviceType: '',
        quantity: '',
        upgradeTime: '',
        remark: ''
      },
      editData: {}
    }
  },
  mounted() {
    this.createTimeBegin = new Date(Utils.getCurrentDate() + ' 00:00').getTime();
    this.createTimeEnd = new Date(Utils.getCurrentDate() + ' 23:59').getTime();
    this.startTimeBegin = new Date(Utils.getCurrentDate() + ' 00:00').getTime();
    this.startTimeEnd = new Date(Utils.getCurrentDate() + ' 23:59').getTime();
    this.queryDeviceUpgradeTask();
  },
  mounted() {
    this.queryDeviceUpgradeTask();
  },
  methods: {
    onStopClick(item) {
      let self = this;
      let flag;
      if (item.status == 0) {
        flag = "中止";
      } else if (item.status == 1) {
        flag = "继续"
      } else {
        self.$message({
          type: "error",
          message: "状态有误!",
          center: true
        });
      }
      this.$confirm('确定' + flag + '升级任务吗？', '提示', {
        type: 'warning'
      }).then(() => {
        self.changeStatus(item.number);
      }).catch(() => {

      });
    },
    cancelHandle() {
      this.view = 'list';
      this.queryDeviceUpgradeTask();
    },
    changeStatus(number) {
      let self = this;
      let params = {
        number: number
      }
      this.$http.post('/managementPlatform/admin/cancelDeviceUpgradeTask', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          });
          return;
        }
        self.$message({
          type: "success",
          message: "操作成功",
          center: true
        });
        self.queryDeviceUpgradeTask();
      }).catch(function (response) {
        console.log(response);
      });
    },
    onAddBtnClick() {
      this.addData = {
        number: '',
        deviceType: '',
        quantity: '',
        upgradeTime: '',
        remark: ''
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.fileUpload.clearFiles();
      });
    },
    queryDeviceUpgradeTask() {
      let self = this;
      let params = {
        beginIndex: this.beginIndex,
        pageSize: this.pageSize + 1,
        createTimeBegin: this.createTimeBegin,
        createTimeEnd: this.createTimeEnd,
        startTimeBegin: this.startTimeBegin,
        startTimeEnd: this.startTimeEnd,
        number: this.number,
        status: this.status
      };
      this.$http.post('/managementPlatform/admin/queryDeviceUpgradeTask', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          });
          return;
        }
        self.dataList = res.ldata;
        self.resetPreAndNextBtn(self.dataList.length);
        self.dataList.length > self.pageSize && self.dataList.pop();
        self.page = Math.floor(self.beginIndex / self.pageSize) + 1;
        self.pageIndex = self.page;
        self.total = res.mdata.total;
        self.totalPage = Math.floor((parseInt(res.mdata.total) - 1) / self.pageSize) + 1;
      }).catch(function (response) {
        console.log(response);
      });
    },
    onDetailBtnClick(data) {
      this.view = 'detail';
      this.$nextTick(() => {
        this.editData = data;
      });
    },
    onPreBtnClick() {
      if (this.preBtnDisabled) {
        return;
      }
      this.beginIndex <= this.pageSize && (this.beginIndex = 0);
      this.beginIndex > this.pageSize && (this.beginIndex -= this.pageSize);
      this.queryDeviceUpgradeTask();
    },
    onNextBtnClick() {
      if (this.nextBtnDisabled) {
        return;
      }
      this.beginIndex += this.pageSize;
      this.queryDeviceUpgradeTask();
    },
    resetPreAndNextBtn(length) {
      this.beginIndex == 0 && (this.preBtnDisabled = true);
      this.beginIndex > 0 && (this.preBtnDisabled = false);
      length > this.pageSize && (this.nextBtnDisabled = false);
      length <= this.pageSize && (this.nextBtnDisabled = true);
    },
    onQueryBtnClick() {
      this.beginIndex = 0;
      this.queryDeviceUpgradeTask();
    },
    onPageChooseBtnClick() {
      let index = 0;
      if (this.page <= this.totalPage && this.page > 0) {
        index = this.page;
      } else {
        index = 1;
        this.page = 1;
      }
      this.beginIndex = (index - 1) * this.pageSize;
      this.queryDeviceUpgradeTask();
    },
    uploadSuccess(res, file) {
      if (res.result == 1) {
        this.file = file.raw;
        this.addData.number = res.mdata.number;
        this.addData.deviceType = res.mdata.deviceType;
        this.addData.quantity = res.mdata.quantity;
      } else {
        this.$message({
          type: "error",
          message: res.message || "查询失败!",
          center: true
        });
      }
    },
    cancel() {
      this.dialogVisible = false;
    },
    confirmAdd() {
      if (!this.file) {
        this.$message({
          type: "warning",
          message: "请上传文件!",
          center: true
        });
        return;
      }
      if (!this.addData.upgradeTime) {
        this.$message({
          type: "warning",
          message: "请选择时间!",
          center: true
        });
        return;
      }
      let params = {
        ...this.addData,
        excelFile: this.file
      };
      let formData = new FormData();
      for (let key in params) {
        formData.append(key, params[key]);
      }
      this.$http.post('/managementPlatform/admin/createDeviceUpgradeTask', formData).then(response => {
        let res = response.data;
        if (!res || !res.result) {
          this.$message({
            type: "error",
            message: res.message || "操作失败!",
            center: true
          });
          return;
        }
        this.dialogVisible = false;
        this.$message({
          type: "success",
          message: '添加成功',
          center: true
        });
        this.queryDeviceUpgradeTask();
      }).catch(err => {
        console.log(err);
      });
    }
  },
}
</script>
<style lang="scss" scoped>
.list {
  line-height: 30px;
  margin: 20px 30px 10px;
  overflow: hidden;

  .name-label {
    float: left;
  }

  .value-label {
    float: left;
    width: 17%;
    height: 30px;
  }

  .date-global {
    width: 185px;
  }

  .list-input {
    width: 180px;
  }
}

.table-custom {
  .text-btn {
    width: 50px;
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #BEE6B3;
    cursor: pointer;
  }

  .fixed-width-75 {
    width: 75px;
  }

  .fixed-width-120 {
    width: 120px;
  }

  .fixed-width-60 {
    width: 60px;
  }
}

.ml-40 {
  margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/deviceUpgradeTask.vue